import React, {useEffect, useState} from 'react';
import './App.scss';
import {BrowserRouter, Navigate, NavigateProps, Route, Routes} from 'react-router-dom'
import Navbar from "./components/navbar/Navbar";
import {useAppDispatch, useAppSelector} from "./store/store";
import {useAuth} from "./hooks/auth.hook";
import {authSlice} from './store/redusers/authSlice';
import {appSlice} from './store/redusers/appSlice';
import {AppRoutes, routeConfig} from "./app/routeConfig";
import {Languages, UserRoles} from "./shared/types";
import {useUser} from "./hooks/user.hook";
import {message as messageAnt} from "antd";
import dayjs from "dayjs";
import './i18n';
import {useTranslation} from 'react-i18next';

function App() {

  const {t, i18n} = useTranslation();
  const dispatch = useAppDispatch()

  const userIdInStore = useAppSelector(state => state.authReduser.userId)
  const tokenInStore = useAppSelector(state => state.authReduser.token)
  const screenWidth = useAppSelector(state => state.appReduser.screenWidth)

  const {auth, setRole, setUserName} = authSlice.actions
  const {setScreenWidth} = appSlice.actions

  const [isAuth, setIsAuth] = useState<boolean>(false)
  const [user, setUser] = useState<string>()
  const [userRole, setUserRole] = useState<UserRoles>()

  const {token, userId, ready} = useAuth()
  const {loading: loadingUser, getUser, error: errorUser, clearError: clearErrorUser} = useUser()

  //определение языка в браузере
  const userLocale = navigator.languages ? navigator.languages[0] : navigator.language;
  const [lang, setLang] = useState<Languages | undefined>()
  useEffect(() => {
    if (userLocale === 'ru-RU' || userLocale === 'ru') {
      setLang('ru')
      i18n.changeLanguage('ru')
    } else {
      setLang('en')
      i18n.changeLanguage('en')
    }
  }, [userLocale])

  //определение ширина окна браузера
  useEffect(() => {
    // let width = window.screen.availWidth
    // if (width < 360) {
    //   width = 360
    // } else if (width > 520) {
    //   width = 520
    // }
    const width = 520//жесткое значение, чтобы не было проблем с адаптивом канвасов
    dispatch(setScreenWidth({screenWidth: width}))
  }, [])

  //изменение статуса авторизации если в локальном хранилище обнаружен токен
  useEffect(() => {
    if (token && userId && ready) {
      dispatch(auth({userId, token}))
      setIsAuth(true)
    }
  }, [token, userId, ready])

  //изменение статуса авторизации если в сторе обнаружен токен
  useEffect(() => {
    if (userIdInStore && tokenInStore) {
      setIsAuth(true)
    } else {
      setIsAuth(false)
    }
  }, [userIdInStore, tokenInStore])

  //добавление в стор роли пользователя и логина
  useEffect(() => {
    if (userRole && user) {
      dispatch(setRole({userRole}))
      dispatch(setUserName({userName: user}))
    }
  }, [userRole, user])

  //функция получение имени пользователя и его роли по его id из БД
  const getOneUser = async (userId: string) => {
    try {
      const data = await getUser(userId)
      // messageAnt.info(data.message)
      const user = data.info
      return user
    } catch (e) {
      // messageAnt.info(errorUser);
      clearErrorUser()
      return undefined
    }
  }

  //изначальное получение имени залогиненого пользователя и его роли по его id из БД
  useEffect(() => {
    if (userIdInStore) {
      const get = async () => {
        const user = await getOneUser(userIdInStore)
        if (user) {
          setUser(user.email)
          setUserRole(user.role)
        }
      }
      get()
    }
  }, [userIdInStore])

  if (!ready || (ready && userId && (!user || !userRole))) {
    return null
  }

  if (!screenWidth) {
    return null
  }

  if (!lang) {
    return null
  }

  return (
    <BrowserRouter>
      <div className="App">
        <div className={'AppHeader'}>
          <Navbar/>
        </div>
        <div className={'AppContent'}>
          <div className="wrap">
            {
              !isAuth ?
                <Routes>
                  {
                    <Route path={routeConfig.mainTitle.routeProps.path}
                           element={routeConfig.mainTitle.routeProps.element}/>
                  }
                  {
                    <Route path={routeConfig.registration.routeProps.path}
                           element={routeConfig.registration.routeProps.element}/>
                  }
                  {
                    <Route path={routeConfig.login.routeProps.path} element={routeConfig.login.routeProps.element}/>
                  }
                  <Route path={'*'}
                         element={<Navigate to={routeConfig.mainTitle.routeProps.path as NavigateProps['to']}/>}/>
                </Routes>
                :
                <Routes>
                  {
                    Object.keys(routeConfig).map((routeKey) => {
                      const route = routeConfig[routeKey as keyof typeof routeConfig]
                      return route.forAuth &&
                        <Route key={route.routeProps.path} path={route.routeProps.path}
                               element={route.routeProps.element}/>
                    })
                  }
                  <Route path={'*'}
                         element={<Navigate to={routeConfig.mainTitle.routeProps.path as NavigateProps['to']}/>}/>
                </Routes>
            }
          </div>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
